export default {
  formValidation: {
    emptyField: 'Le champ ne peut pas être vide',
    requiredField: 'Le champ est obligatoire',
    passwordToShort: 'Le mot de passe doit comporter 8 caractères',
    emailNotValid: 'Le champ doit contenir une adresse électronique valide',
    emailReserved: "L'adresse électronique est déjà prise",
    rateEmpty: 'Tous les champs doivent être remplis',
    serverUnknownError: 'Erreur de communication avec le serveur',
    invalidCharacters: 'Le champ contient des caractères non valides',
    phoneNotValid: 'Le numéro de téléphone est incorrect',
    checkBoxBelow: 'Veuillez cocher la case ci-dessous pour envoyer un message',
  },
  password: {
    show: 'afficher',
    hide: 'cacher',
  },
  howItWorks: {
    showButton: 'Afficher plus',
    hideButton: 'Afficher moins',
  },
}
